module.exports = __webpack_public_path__ + "img/interior_design.fbfdd02d.jpg";